import { Link } from "react-router-dom";
import chatbotImg from "../assets/img/chatbot.svg";
import logo from "../assets/img/trini-talk-bot-big.svg";
import Toast from "../components/info/Toast";
import { LockIcon, UserIcon } from "../components/Icons";
import useAuth from "../hooks/useAuth";
import AlertMsg from "../components/info/AlertMsg";

function RegisterInvitedUser() {
  document.title = "Registro | Trini Talkbot";

  const {
    handleChangeRegister,
    handleSubmitRegisterInvitedUser,
    dataRegister,
    errorMsg,
  } = useAuth();

  return (
    <>
      <div className={"container sign-up-mode"}>
        <Toast />
        <div className="forms-container">
          <div className="signin-signup">
            <form
              onSubmit={handleSubmitRegisterInvitedUser}
              className="sign-up-form"
            >
              <h2 className="titleLogin">Registrarse</h2>
              <div>
                {errorMsg && <AlertMsg type="danger" text={errorMsg} />}
              </div>
              <div className="input-field">
                <UserIcon color="#212529" />
                <input
                  type="text"
                  placeholder="Ingresa tu nombre.."
                  id="nameregister"
                  name="name"
                  onChange={handleChangeRegister}
                  value={dataRegister.name}
                  maxLength={70}
                />
              </div>
              <div className="input-field">
                <UserIcon color="#212529" />
                <input
                  type="text"
                  placeholder="Ingresa un nombre de usuario.."
                  id="usernameregister"
                  name="username"
                  onChange={handleChangeRegister}
                  value={dataRegister.username}
                  maxLength={60}
                />
              </div>
              <div className="input-field">
                <LockIcon color="#212529" />
                <input
                  type="password"
                  placeholder="Ingresa una contraseña.."
                  id="passwordregister"
                  name="password"
                  onChange={handleChangeRegister}
                  value={dataRegister.password}
                  autoComplete="on"
                  maxLength={60}
                />
              </div>
              <div className="input-field">
                <LockIcon color="#212529" />
                <input
                  type="password"
                  placeholder="Repite la contraseña.."
                  id="password2"
                  name="password2"
                  onChange={handleChangeRegister}
                  value={dataRegister.password2}
                  autoComplete="off"
                  maxLength={60}
                />
              </div>
              <button type="submit" className="btnlogin">
                Registrarme
              </button>
            </form>
          </div>
        </div>

        <div className="panels-container">
          <div className="panel left-panel"></div>
          <div className="panel right-panel">
            <div className="content">
              <img
                src={logo}
                alt="trini logo"
                className="imageLogo"
                onClick={() => {
                  location.href = "https://trinitalkbot.com/";
                }}
                style={{ cursor: "pointer" }}
              />
              <p className="loginSub">
                ¿Ya tienes una cuenta? Ingresa haciendo clic aquí.
              </p>
              <Link
                to="/login"
                id="sign-in-btn"
                className="btn btnlogin transparent"
                style={{ lineHeight: "2" }}
              >
                <span>Ingresar</span>
              </Link>
            </div>
            <img src={chatbotImg} className="image" alt="" />
          </div>
        </div>
      </div>
    </>
  );
}

export default RegisterInvitedUser;
